// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"187":"87c9994a7857916f2634","341":"759864cf8e59a478e6a8","722":"ba0927f6a3b01e95699d"}[chunkId] + ".css";
};